import React from 'react';
import {Alert,Box,Button,Card,CardContent,LinearProgress,Typography} from '@mui/material';
import {useAchievements} from '../hooks/useAchievements';

export default function AchievementsSystem({token}:{token:string|null;userId?:string}){
 const {achievements,dailyTasks,isLoading,error,reload,completeTask}=useAchievements(token);
 return <Card><CardContent><Typography variant="h5">Достижения и задания</Typography>
  <Typography>Сохранённые отметки прогресса. Баллы за эти задания не начисляются.</Typography>
  <Button disabled={isLoading} onClick={()=>void reload()}>Обновить</Button>
  {isLoading&&<Typography>Загружаем данные...</Typography>}{error&&<Alert severity="error">{error}</Alert>}
  {!isLoading&&!error&&<Box><Typography variant="h6">Достижения</Typography>
   {achievements.length===0&&<Typography>Сохранённых достижений пока нет.</Typography>}
   {achievements.map(item=><Box key={item.source+item.id} sx={{my:2}}><Typography>{item.title}</Typography>
    {item.description&&<Typography>{item.description}</Typography>}
    <Typography>{item.is_completed?'Сохранено как выполненное':'В процессе'}</Typography>
    <Typography>{item.verification==='self_reported'?'По вашим отметкам о прохождении':'Историческая запись без проверки навыка'}</Typography>
    {item.progress!==null&&item.target!==null&&item.target>0&&<LinearProgress variant="determinate" value={Math.max(0,Math.min(100,item.progress/item.target*100))}/>}
   </Box>)}
   <Typography variant="h6">Задание на сегодня</Typography>
   {dailyTasks.length===0&&<Typography>На сегодня нет активного задания.</Typography>}
   {dailyTasks.map(task=><Box key={task.id} sx={{my:2}}><Typography>{task.challenge_type==='memory_game'?'Упражнение на память':'Задание на сегодня'}</Typography>
    <Typography>Отметка о выполнении сохраняется без начисления награды.</Typography>
    <Button disabled={task.is_completed||isLoading} onClick={()=>void completeTask(task.id)}>{task.is_completed?'Выполнение сохранено':'Отметить выполненным'}</Button>
   </Box>)}
  </Box>}
 </CardContent></Card>;
}
